function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24 2C11.8697 2 2 11.8697 2 24C2 36.1303 11.8697 46 24 46C36.1303 46 46 36.1303 46 24C46 11.8697 36.1303 2 24 2Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24 37C25.5533 37 26.8125 35.9418 26.8125 34.6364C26.8125 33.331 25.5533 32.2727 24 32.2727C22.4467 32.2727 21.1875 33.331 21.1875 34.6364C21.1875 35.9418 22.4467 37 24 37Z",
  fill: "#FAAD14"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M24 11C19.0374 11 15 14.393 15 18.5636C15 19.608 16.0073 20.4545 17.25 20.4545C18.4927 20.4545 19.5 19.608 19.5 18.5636C19.5 16.4783 21.5187 14.7818 24 14.7818C26.4813 14.7818 28.5 16.4783 28.5 18.5636C28.5 20.6489 26.4813 22.3455 24 22.3455C22.7573 22.3455 21.75 23.192 21.75 24.2364V28.9636C21.75 30.008 22.7573 30.8545 24 30.8545C25.2427 30.8545 26.25 30.008 26.25 28.9636V25.888C30.1274 25.0462 33 22.0816 33 18.5636C33 14.393 28.9626 11 24 11Z",
  fill: "#FAAD14"
});

function SvgAlertDecisionWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertDecisionWarning);
export default __webpack_public_path__ + "static/media/alert-decision-warning.f74146d9.svg";
export { ForwardRef as ReactComponent };